export default "__VITE_ASSET__5$pdG8l3__"